const globalMixin = {
  computed: {
    user() {
      return this.$store.state.user || {};
    }
  }
};

export default globalMixin;
